import { render, staticRenderFns } from "./BaseFormInput.vue?vue&type=template&id=096f904d&scoped=true&"
import script from "./BaseFormInput.vue?vue&type=script&lang=js&"
export * from "./BaseFormInput.vue?vue&type=script&lang=js&"
import style0 from "./BaseFormInput.vue?vue&type=style&index=0&id=096f904d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "096f904d",
  null
  
)

export default component.exports